export enum BulkUploadErrorType {
    PARSE_ERROR,
    FILE_TOO_LARGE,
    REQUIRED,
    DUPLICATE_TITLE,
    UNKNOWN,
}
